import React from "react";
import { Navigate, useNavigate } from "react-router-dom";

const adminAuth = (Component) => {
  // const navigate = useNavigate()
  return (props) => {
    if (sessionStorage.getItem("adminToken") !== "success") {
      return <Navigate to="/adminLogin" />;
    } else {
      return <Component {...props} />;
    }
  };
};

export default adminAuth;